import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let linked_document = useDataValue({
    viewPath: props.viewPath,
    context: 'linked_document',
  })
  let submit = useDataSubmit({
    context: 'patient_image',
    viewPath: props.viewPath,
  })

  return async function onClick() {
    submit({
      type: 'open_linked_document_modal_fullscreen',
      linked_document,
    })
  }
}
